/**
 * T064: Index Route
 * Redirect from / to /prompts
 */

import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/prompts' })
  },
})
